import type { RouteRecordRaw } from 'vue-router';

export const tradeSupportRoutes: Array<RouteRecordRaw> = [
  {
    path: '/trade/support',
    name: 'tradeSupport',
    redirect: '/trade/support/request',
  },
  {
    path: '/trade/support/category',
    name: 'tradeSupportCategory',
    redirect: '/trade/support/category/list',
    component: () => import('pages/micros/support/category/SupportCategory.vue'),
    meta: {
      title: 'Support Categories, by group - request, blog, chat, comment, message',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSupportCategoryList',
        component: () => import('pages/micros/support/category/CategoryList.vue'),
        meta: {
          title: 'Support Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSupportCategoryDetail',
        component: () => import('pages/micros/support/category/CategoryDetail.vue'),
        meta: {
          title: 'Support Category Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSupportCategoryNew',
        component: () => import('pages/micros/support/category/CategoryNew.vue'),
        meta: {
          title: 'New Support Category',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'tradeSupportCategoryExplorer',
        component: () => import('pages/micros/support/category/CategoryExplorer.vue'),
        meta: {
          title: 'Categories Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/support/room',
    name: 'tradeSupportRoom',
    redirect: '/trade/support/room/list',
    component: () => import('pages/micros/support/room/SupportRoom.vue'),
    meta: {
      title: 'Rooms [Support Groups] by categories - Public, Private, Message, Request, Blog, Chat',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSupportRoomList',
        component: () => import('pages/micros/support/room/RoomList.vue'),
        meta: {
          title: 'Rooms [Support Groups] List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSupportRoomDetail',
        component: () => import('pages/micros/support/room/RoomDetail.vue'),
        meta: {
          title: 'Room [Support Group] Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSupportRoomNew',
        component: () => import('pages/micros/support/room/RoomNew.vue'),
        meta: {
          title: 'New Room [Support Group]',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/support/room/member',
    name: 'tradeSupportRoomMember',
    redirect: '/trade/support/room/member/list',
    component: () => import('pages/micros/support/roomMember/SupportRoomMember.vue'),
    meta: {
      title: 'Room Memberships - for private rooms',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSupportRoomMemberList',
        component: () => import('pages/micros/support/roomMember/RoomMemberList.vue'),
        meta: {
          title: 'Room Memberships List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSupportRoomMemberDetail',
        component: () => import('pages/micros/support/roomMember/RoomMemberDetail.vue'),
        meta: {
          title: 'Room Membership Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSupportRoomMemberNew',
        component: () => import('pages/micros/support/roomMember/RoomMemberNew.vue'),
        meta: {
          title: 'New Room Membership',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/support/blog',
    name: 'tradeSupportBlog',
    redirect: '/trade/support/blog/list',
    component: () => import('pages/micros/support/blog/SupportBlog.vue'),
    meta: {
      title: 'Blogs - general, news, product etc.',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSupportBlogList',
        component: () => import('pages/micros/support/blog/BlogList.vue'),
        meta: {
          title: 'Blogs List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSupportBlogDetail',
        component: () => import('pages/micros/support/blog/BlogDetail.vue'),
        meta: {
          title: 'Blog Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSupportBlogNew',
        component: () => import('pages/micros/support/blog/BlogNew.vue'),
        meta: {
          title: 'New Blog',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'tradeSupportBlogExplorer',
        component: () => import('pages/micros/support/blog/BlogExplorer.vue'),
        meta: {
          title: 'Blogs Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/support/chat',
    name: 'tradeSupportChat',
    redirect: '/trade/support/chat/list',
    component: () => import('pages/micros/support/chat/SupportChat.vue'),
    meta: {
      title: 'Chats - P2P | P2Group or P2Room real-time/off-line conversations',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSupportChatList',
        component: () => import('pages/micros/support/chat/SioChats.vue'),
        meta: {
          title: 'Chats List - P2P Chats',
          requiresAuth: true,
        },
      },
      {
        path: 'room/chats',
        name: 'tradeSupportRoomChats',
        component: () => import('pages/micros/support/chat/SioRooms.vue'),
        meta: {
          title: 'Room Chats List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSupportChatDetail',
        component: () => import('pages/micros/support/chat/SioChatDetail.vue'),
        meta: {
          title: 'Chat Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSupportChatNew',
        component: () => import('pages/micros/support/chat/ChatNew.vue'),
        meta: {
          title: 'New Chat',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'tradeSupportChatExplorer',
        component: () => import('pages/micros/support/chat/ChatExplorer.vue'),
        meta: {
          title: 'Chats Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'status/list',
        name: 'tradeSupportChatStatusList',
        component: () => import('pages/micros/support/chatStatus/SioChatStatusList.vue'),
        meta: {
          title: 'Chat Statuses List',
          requiresAuth: true,
        },
      },
      {
        path: 'status/detail/:itemId?',
        name: 'tradeSupportChatStatusDetail',
        component: () => import('pages/micros/support/chatStatus/SioChatStatusDetail.vue'),
        meta: {
          title: 'ChatStatus Details',
          requiresAuth: true,
        },
      },
      {
        path: 'status/new',
        name: 'tradeSupportChatStatusNew',
        component: () => import('pages/micros/support/chatStatus/ChatStatusNew.vue'),
        meta: {
          title: 'New Chat Status',
          requiresAuth: true,
        },
      },
      {
        path: 'access/list',
        name: 'tradeSupportChatAccessList',
        component: () => import('pages/micros/support/chatAccess/SioChatAccessList.vue'),
        meta: {
          title: 'Chat Accesses List',
          requiresAuth: true,
        },
      },
      {
        path: 'access/detail/:itemId?',
        name: 'tradeSupportChatAccessDetail',
        component: () => import('pages/micros/support/chatAccess/SioChatAccessDetail.vue'),
        meta: {
          title: 'Chat Access Details',
          requiresAuth: true,
        },
      },
      {
        path: 'access/new',
        name: 'tradeSupportChatAccessNew',
        component: () => import('pages/micros/support/chatAccess/ChatAccessNew.vue'),
        meta: {
          title: 'New Chat Access',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/support/chats',
    name: 'tradeSupportChats',
    component: () => import('pages/micros/support/chat/SioChats.vue'),
    meta: {
      title: 'Chats [P2P | User]',
      requiresAuth: true,
    },
  },
  {
    path: '/trade/support/p2p/chat',
    name: 'tradeSupportP2PChat',
    component: () => import('pages/micros/support/chat/P2PChat.vue'),
    meta: {
      title: 'P2P Chat [Registered user and/or Guest]',
      requiresAuth: false,
    },
  },
  {
    path: '/trade/support/rooms',
    name: 'tradeSupportRooms',
    component: () => import('pages/micros/support/chat/SioRooms.vue'),
    meta: {
      title: 'Chat Rooms',
      requiresAuth: true,
    },
  },
  {
    path: '/trade/support/join/room',
    name: 'tradeSupportJoinRoom',
    component: () => import('pages/micros/support/chat/SioJoinRoom.vue'),
    meta: {
      title: 'Join Rooms',
      requiresAuth: true,
    },
  },
  {
    path: '/trade/support/message',
    name: 'tradeSupportMessage',
    redirect: '/trade/support/message/list',
    component: () => import('pages/micros/support/message/SupportMessage.vue'),
    meta: {
      title: 'Messages - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSupportMessageList',
        component: () => import('pages/micros/support/message/MessageExplorerList.vue'),
        meta: {
          title: 'Messages List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:taskType?',
        name: 'tradeSupportMessageDetail',
        component: () => import('pages/micros/support/message/MessageDetail.vue'),
        meta: {
          title: 'Message Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSupportMessageNew',
        component: () => import('pages/micros/support/message/MessageNew.vue'),
        meta: {
          title: 'New Message',
          requiresAuth: true,
        },
      },
      {
        path: 'status/list',
        name: 'tradeSupportMessageStatusList',
        component: () => import('pages/micros/support/message/MessageStatusList.vue'),
        meta: {
          title: 'Message Statuses List',
          requiresAuth: true,
        },
      },
      {
        path: 'status/detail/:itemId?',
        name: 'tradeSupportMessageStatusDetail',
        component: () => import('pages/micros/support/message/MessageStatusDetail.vue'),
        meta: {
          title: 'Message Status Details',
          requiresAuth: true,
        },
      },
      {
        path: 'status/new',
        name: 'tradeSupportMessageStatusNew',
        component: () => import('pages/micros/support/message/MessageStatusNew.vue'),
        meta: {
          title: 'New Message Status',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/support/request',
    name: 'tradeSupportRequest',
    redirect: '/trade/support/request/list',
    component: () => import('pages/micros/support/request/SupportRequest.vue'),
    meta: {
      title: 'Requests - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSupportRequestList',
        component: () => import('pages/micros/support/request/RequestList.vue'),
        meta: {
          title: 'Requests List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSupportRequestDetail',
        component: () => import('pages/micros/support/request/RequestDetail.vue'),
        meta: {
          title: 'Request Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSupportRequestNew',
        component: () => import('pages/micros/support/request/RequestNew.vue'),
        meta: {
          title: 'New Request',
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/trade/support/comment',
    name: 'tradeSupportComment',
    redirect: '/trade/support/comment/list',
    component: () => import('pages/micros/support/comment/SupportComment.vue'),
    meta: {
      title: 'Support Comments - for product items...',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSupportCommentList',
        component: () => import('pages/micros/support/comment/CommentList.vue'),
        meta: {
          title: 'Comments List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSupportCommentDetail',
        component: () => import('pages/micros/support/comment/CommentDetail.vue'),
        meta: {
          title: 'Comment Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSupportCommentNew',
        component: () => import('pages/micros/support/comment/CommentNew.vue'),
        meta: {
          title: 'New Comment',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/list',
        name: 'tradeSupportCommentStatList',
        component: () => import('pages/micros/support/commentStat/CommentStatList.vue'),
        meta: {
          title: 'Comment Stats List',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/detail/:itemId?',
        name: 'tradeSupportCommentStatDetail',
        component: () => import('pages/micros/support/commentStat/CommentStatDetail.vue'),
        meta: {
          title: 'Comment Stat Details',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/new',
        name: 'tradeSupportCommentStatNew',
        component: () => import('pages/micros/support/commentStat/CommentStatNew.vue'),
        meta: {
          title: 'New Comment Stat',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/support/rate',
    name: 'tradeSupportRate',
    redirect: '/trade/support/rate/list',
    component: () => import('pages/micros/support/rate/SupportRate.vue'),
    meta: {
      title: 'Rates - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSupportRateList',
        component: () => import('pages/micros/support/rate/RateList.vue'),
        meta: {
          title: 'Rates List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSupportRateDetail',
        component: () => import('pages/micros/support/rate/RateDetail.vue'),
        meta: {
          title: 'Rate Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSupportRateNew',
        component: () => import('pages/micros/support/rate/RateNew.vue'),
        meta: {
          title: 'New Rate',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/support/rating',
    name: 'tradeSupportRating',
    redirect: '/trade/support/rating/list',
    component: () => import('pages/micros/support/rating/SupportRating.vue'),
    meta: {
      title: 'Ratings - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSupportRatingList',
        component: () => import('pages/micros/support/rating/RatingList.vue'),
        meta: {
          title: 'Ratings List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSupportRatingDetail',
        component: () => import('pages/micros/support/rating/RatingDetail.vue'),
        meta: {
          title: 'Rating Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSupportRatingNew',
        component: () => import('pages/micros/support/rating/RatingNew.vue'),
        meta: {
          title: 'New Rating',
          requiresAuth: true,
        },
      },
    ],
  },
];
